<app-edit-field
  *ngIf="myField"
  [sectionsContainer]="sectionsContainer"
  [field]="myField"
  [object]="compareObject"
  [index]="index"
  [parentIndex]="parentIndex"
></app-edit-field>
